import React, { ReactElement } from 'react'

import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '../../Svg/Svg'

export const FamilyIcon = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M1.00008 15.6613C0.99086 13.8253 1.77223 12.074 3.14481 10.8545"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.39651 8.24881C7.80167 7.44942 7.84616 6.51505 7.51879 5.68077C7.1739 4.84995 6.40077 4.27552 5.50576 4.18511C4.7131 4.16265 3.95514 4.51034 3.45509 5.12578C2.9403 5.73416 2.66889 6.51155 2.69315 7.30814C2.69231 8.55381 3.6777 9.57662 4.92254 9.62219C6.67219 9.96083 10.021 10.4594 9.92691 15.7177"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7302 16C13.2194 14.5796 12.956 9.5564 9.36264 9.1331C10.6688 8.56093 11.3721 7.13041 11.0276 5.74668C10.8689 5.14284 10.4756 4.62738 9.93512 4.31476C9.39466 4.00214 8.75176 3.91824 8.14917 4.08169"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.004 15.9152C16.3426 15.0216 16.1357 11.8891 13.6241 11.6069C14.4999 11.3189 15.0047 10.4036 14.7811 9.50924C14.4949 8.67937 13.6164 8.21138 12.7681 8.43688"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9012 15.9152C19.2398 15.0216 19.0329 11.8891 16.5213 11.6069C17.3971 11.3189 17.9019 10.4036 17.6783 9.50924C17.3922 8.67937 16.5137 8.21138 15.6653 8.43688"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)
